<template>
  <div>
    <b-row>
      <b-col>
        <b-row lg="12" v-if="noListings && !openListings" class="subtle-hints">
          <p style="margin: 0 auto">No Archived Properties</p>
        </b-row>
        <b-row
          lg="12"
          v-else-if="noListings && openListings && progress == 100"
          class="subtle-hints"
        >

          <moow-empty-state
            imageUri="./static/add_listing.svg"
            :title="i18n_local.info.add_first_prop"
            :description="i18n_local.info.manage_properties"
            :ctaButtonText="i18n_local.ui.add_property"
            @emitCtaClick="createNewListing()"
          />
        </b-row>
        <b-row v-else-if="!noListings && openListings">
          <b-col lg="8" cols="12">
            <md-field md-clearable @md-clear="resetFilters">
              <label>Search by id, title, address or info</label>
              <md-input :value="propertySearch_input" @input="filterProperties"></md-input>
            </md-field>
          </b-col>
          <b-col lg="3" cols="0">
              
            <!-- TODO: when stable, add the check for v-if="userRoleCanEditListings" -->
            <moow-button
              :type="['light']"
              :btnText="i18n_local.ui.add_property"
              @mClick="createNewListing"
              :camel="true"

            />
          </b-col>
        </b-row>

        <moow-empty-state
          v-if="showFilteringDescriptor"
          icon="search"
          :title="i18n_local.filtered_props_appear"
          :description="filteringDescription"
        />

        <b-row
          v-else
          lg="12"
          v-for="(data, index) in filteredListings"
          :key="index/data.maaklerID"
          class="dash-element-container play-shadow"
        >
          <b-row v-if="data.loading">
            <ContentLoader style="height:155; width:400">
              <rect x="200" y="15" rx="3" ry="3" width="185" height="20" />
              <rect x="200" y="70" rx="3" ry="3" width="113" height="15" />
              <rect x="200" y="105" rx="0" ry="0" width="90" height="40" />
              <rect x="12" y="15" rx="0" ry="0" width="180" height="120" />
              <rect x="310" y="105" rx="0" ry="0" width="90" height="40" />
            </ContentLoader>
          </b-row>
          <b-container v-else>
            <b-row class="dash-element-holder">
              <b-col lg="4" md="5" sm="12" cols="12" class="dash-element-image-container">
                <clazy-load :src="getCoverImageGate(data.marketingDet.images)" v-if="hasImages(data)">
                  <!-- The image slot renders after the image loads. -->
                  <b-img
                    fluid
                    rounded
                    :src="getCoverImageGate(data.marketingDet.images)"
                    alt="Thumbnail"
                  />
                  <!-- The placeholder slot displays while the image is loading. -->
                  <div slot="placeholder">
                    <!-- You can put any component you want in here. -->
                    <b-img fluid rounded :src="placeholder" alt="Loading" />
                  </div>
                </clazy-load>
                <div v-else-if="hasVideos(data)">
                  <iframe :src="getVideoSrc(data)" frameborder="0" allowfullscreen></iframe>
                </div>
                <b-img fluid rounded :src="placeholder" alt="Loading" v-else />
              </b-col>
              <b-col lg="7" md="6" sm="12" cols="12" class="dash-element-details-container">
                <b-row>
                  <b-col cols="10">
                    <div class="dash-action-container-master">
                      <div class="dash-action-container-header single-line-row-fade">
                        <span
                          class="dash-item-title"
                          v-if="data.marketingDet.shortDesc"
                        >{{data.marketingDet.shortDesc}}</span>
                        <span class="dash-item-title" v-else>No Title</span>
                      </div>
                      <div class="dash-action-container-content">
                        <p class="dash-item-subtitle">{{getDisplayAddressGate(data)}}</p>
                        <span
                          class="dash-item-status"
                          :class="getDisaplyStatusClass(data.availDet.status)"
                        >{{getDisaplyStatusGate(data.availDet.status)}}</span>
                      </div>
                      <div class="dash-action-container-actions" v-if="tabCategory != 'archived'">
                        <div v-if="data.txnDet.priceMonthly" style="text-align: right"><p><strong>{{data.txnDet.priceMonthly}}€</strong>/month</p></div>
                        <div v-else-if="data.txnDet.priceDaily" style="text-align: right"><p><strong>{{data.txnDet.priceDaily}}€</strong>/month</p></div>
                        <b-row class="mt-2" align-h="end">
                          <moow-button
                            :type="['light', 'outlined', 'flat']"
                            btnText="Manage"
                            @mClick="manageListing(data)"
                          />
                          <moow-button
                            id="global-dash-edit-listing"
                            :type="['light', 'outlined','flat']"
                            btnText="Listing"
                            @mClick="editListing(data)"
                            :disabled="!userRoleCanEditListings"
                          />
                          <moow-button
                            :type="['dark', 'link']"
                            class="ml-3"
                            btnText="View"
                            @mClick="previewListing(data.maaklerID)"
                            :tooltip="data.maaklerID.toString()"
                          />
                        </b-row>
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="2">
                    <md-speed-dial md-direction="bottom" v-if="userRoleCanEditListings">
                      <md-speed-dial-target
                        class="md-icon-button md-dense md-primary play-cta-button makeup"
                      >
                        <md-icon>more_vert</md-icon>
                      </md-speed-dial-target>

                      <md-speed-dial-content>
                        <md-button
                          v-if="tabCategory != 'archived'"
                          class="md-icon-button"
                          @click="cloneProperty(data)"
                          :disabled="loading"
                        >
                          <md-icon v-if="!loading">file_copy</md-icon>
                          <md-progress-spinner
                            v-else
                            :md-diameter="30"
                            :md-stroke="3"
                            md-mode="indeterminate"
                          ></md-progress-spinner>
                          <md-tooltip md-direction="right" md-delay="0">Clone</md-tooltip>
                        </md-button>
                        <md-button
                          v-if="tabCategory == 'draft'"
                          class="md-icon-button"
                          @click="archiveListing(data)"
                        >
                          <md-icon>delete_forever</md-icon>
                          <md-tooltip md-direction="right" md-delay="0">Archive</md-tooltip>
                        </md-button>
                        <md-button
                          v-else-if="tabCategory == 'archived'"
                          class="md-icon-button"
                          @click="draftListing(data)"
                        >
                          <md-icon>drafts</md-icon>
                          <md-tooltip md-direction="right" md-delay="0">Move to Stored</md-tooltip>
                        </md-button>
                      </md-speed-dial-content>
                    </md-speed-dial>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";

import { ContentLoader } from "vue-content-loader";
import { filterListingsBasedOn } from "../searchFunctions.js";
import {
  getDisplayStatus,
  getDisplayAddress,
  orderListingsByModDate,
} from "../listingFunctions.js";
import { getCoverImage } from "../listings/images/imageService.js";
import {
  archiveProperty,
  draftProperty,
} from "../platform/properties/services/propertyService";
import { mapGetters } from "vuex";
import { debounce } from "lodash/function";

export default {
  props: {
    progress: {
      type: Number,
      required: false,
      default: 0,
    },
    openListings: {
      type: Boolean,
      default: true,
    },
    dashListings: {
      type: Array,
      required: true,
    },
    filteredProperties: {
      type: Array,
      default: () => [],
    },
    createNewListing: {
      type: Function,
      required: true,
    },
    editListing: {
      type: Function,
      required: true,
    },
    previewListing: {
      type: Function,
      required: true,
    },
    manageListing: {
      type: Function,
      required: false,
    },
    tabCategory: {
      type: String,
      required: false,
    },
  },
  components: {
    ContentLoader,
    InfoToggle,
  },
  data() {
    return {
      propertySearch_input: "",
      loading: false,
    };
  },
  watch: {
    propertySearch_input: function (val, oldVal) {
      if (val) {
          sessionStorage.setItem("lastPropSearchInput", val);
      }
      else {
          sessionStorage.removeItem("lastPropSearchInput");
          this.$emit('resetFilteringRequested');
      }
      // val
      //   ? sessionStorage.setItem("lastPropSearchInput", val)
      //   : sessionStorage.removeItem("lastPropSearchInput");
      //   this.$emit('resetFilteringRequested');
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
      // return "viewer";
    },
    userRoleCanEditListings() {
      console.log('this.currentUserRole: ', this.currentUserRole);
      
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.accountWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    placeholder() {
      return require("../assets/placeholder.png");
    },
    filteredListings() {
        if (this.showFilteringDescriptor) {
            return orderListingsByModDate(this.filteredProperties);
        }

        return orderListingsByModDate(this.dashListings);
      // if (this.propertySearch_input)
      //   return filterListingsBasedOn(
      //     this.dashListings,
      //     this.propertySearch_input
      //   );
      // else {
      //   return orderListingsByModDate(this.dashListings);
      // }
    },
    propertiesRequestPending() {
        return this.$store.getters.propertiesRequestPending;
    },
    showFilteringDescriptor() {
        return this.propertySearch_input && !this.filteredProperties.length;
    },
    filteringDescription() {
        if (this.propertySearch_input.length < 3) {
            return 'At least 3 characters required in order to search';
        }
        if (this.propertiesRequestPending) {
            return `Searching for Properties using keywords "${this.propertySearch_input}"...`;
        }

        return `There are currently no Properties that match keywords "${this.propertySearch_input}"`;
    },
    noListings() {
      return this.dashListings.length == 0;
    },
  },
  created() {
    var memPropSearchInput = sessionStorage.getItem("lastPropSearchInput");
    memPropSearchInput
      ? (this.propertySearch_input = memPropSearchInput)
      : void 0;
  },
  methods: {
    cloneProperty(property) {
      this.loading = true;
      this.$store
        .dispatch("cloneProperty", { property: property })
        .then((clonedProperty) => {
          this.notifyUser("Done", "Property cloned to 'Stored'");
        })
        .catch((err) => {
          console.log("err:", err);
          this.notifyUser("Unable", "Cannot clone property at this time");
        })
        .finally((f) => {
          this.loading = false;
        });
    },
    archiveListing(listing) {
      if (this.tabCategory) archiveProperty(this.tabCategory, listing);
      this.$emit("refresListings");
    },
    draftListing(listing) {
      if (this.tabCategory) draftProperty(this.tabCategory, listing);
      this.$emit("refresListings");
    },
    getDisplayAddressGate(adr) {
      return getDisplayAddress(adr);
    },
    getDisaplyStatusClass(status) {
      if (status == "draft") return "";
      if (status == "active") return "live-flag";
      if (status == "archived") return "archived-flag";
    },
    getDisaplyStatusGate(status) {
      return getDisplayStatus(status);
    },
    getCoverImageGate(img) {
      const src = getCoverImage(img);
      if (!src) return this.placeholder;
      return src;
    },
    availableInCity24(listing) {
      if (this.isPresentInArray(listing.availDet.excludePortals, "city24"))
        return false;
      else return true;
    },
    availableInKv24(listing) {
      if (this.isPresentInArray(listing.availDet.excludePortals, "kv24"))
        return false;
      else return true;
    },
    availableInKv(listing) {
      if (this.isPresentInArray(listing.availDet.excludePortals, "kv"))
        return false;
      else return true;
    },
    availableInReales(listing) {
      if (this.isPresentInArray(listing.availDet.excludePortals, "reales"))
        return false;
      else return true;
    },
    isPresentInArray(ar, findMe) {
      if (!ar) return false;
      var len = ar.length;
      var i = 0;
      for (; i < len; ) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    filterProperties: debounce(function (searchString) {
      this.propertySearch_input = searchString;
      if (!searchString || searchString.length < 3) {
          return;
      }
      this.$emit('filteringRequested', searchString);
    }, 300),
    resetFilters() {
      this.propertySearch_input = '';
      this.$emit('resetFilteringRequested');
    },
    hasImages(property) {
        const { marketingDet: { images } = {} } = property || {};

        return Array.isArray(images) && images.length;
    },
    hasVideos(property) {
        const { marketingDet: { videos } = {} } = property || {};
        if (!Array.isArray(videos) || !videos.length) {
            return false;
        }
        // Checking that it's possible to extract the video url (to avoid "v-if" constructions in the html part)
        const videoSrc = this.getVideoSrc(property);

        return !!videoSrc;
    },
    getYoutubeVideoSrc(src) {
        if (src.indexOf('/embed/') >= 0) {
            return src;
        }
        const chunks = src.split('?v=');
        if (chunks.length !== 2) {
            return '';
        }

        return `//www.youtube.com/embed/${chunks[1]}`;
    },
    getVideoSrc(property) {
        const { marketingDet: { videos } = {} } = property || {};
        if (!Array.isArray(videos) || !videos.length) {
            return '';
        }
        if (videos[0].indexOf('www.youtube.com') >= 0) {
            return this.getYoutubeVideoSrc(videos[0]);
        }

        return videos[0];
    },
  }
};
</script>
<style scoped>
@import "../assets/styles/listings-view.css";
@import "../assets/styles/global.css";
@import "../assets/styles/dashboard.css";
</style>



// WEBPACK FOOTER //
// src/components/dashboardListings.vue